import { Fragment } from 'react';
import { TextKey, RouteName } from '@mews-commander/enums';
import { IconName } from '@optimus-web/core';
import { isCurrentEnterpriseActivityReportEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import {
    isCurrentProfileEnabledToManageCustomers,
    canCurrentProfileViewSensitiveReports,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { getSelectedServiceId } from '@mews-commander/legacy-entities/src/ducks/serviceSelect';
import { useCommanderSelector } from '@mews-commander/utils';
import DashboardTextLink from '../DashboardTextLink';
import DashboardTitle from '../DashboardTitle';

export const ReportsLinksSection: React.FC = () => {
    const showTimeSpentReport = useCommanderSelector<boolean>(isCurrentProfileEnabledToManageCustomers);
    const canViewSensitiveReports = useCommanderSelector<boolean>(canCurrentProfileViewSensitiveReports);
    const activityReportEnabled = useCommanderSelector<boolean>(isCurrentEnterpriseActivityReportEnabled);
    const serviceId = useCommanderSelector(getSelectedServiceId);

    return (
        <Fragment>
            <DashboardTitle textKey={TextKey.ReportPlural} />

            <DashboardTextLink
                textKey={TextKey.ProductReport}
                iconName={IconName.ProductReport}
                route={RouteName.ProductReportIndex}
                routeParams={{
                    query: {
                        Mode: 'New',
                        'Service.Id': serviceId,
                    },
                }}
            />

            <DashboardTextLink
                textKey={TextKey.ProductCheckList}
                iconName={IconName.ProductReport}
                route={RouteName.ProductCheckListIndex}
            />

            {canViewSensitiveReports && (
                <DashboardTextLink
                    textKey={TextKey.ManagerReport}
                    iconName={IconName.ManagerReport}
                    route={RouteName.ManagerReportIndex}
                />
            )}

            <DashboardTextLink
                textKey={TextKey.PostingJournalReport}
                iconName={IconName.PostingJournal}
                route={RouteName.PostingJournalReportIndex}
            />

            <DashboardTextLink
                textKey={TextKey.ActionLogItemReport}
                iconName={IconName.ActionLog}
                route={RouteName.EventReportIndex}
            />

            {activityReportEnabled && (
                <DashboardTextLink
                    textKey={TextKey.ActivityReport}
                    iconName={IconName.ActivityReport}
                    route={RouteName.ActivityReportIndex}
                />
            )}

            {showTimeSpentReport && (
                <DashboardTextLink
                    textKey={TextKey.TimeSpentReport}
                    iconName={IconName.SpentNights}
                    route={RouteName.TimeSpentReportIndex}
                />
            )}
        </Fragment>
    );
};
